export default __webpack_public_path__ + "static/media/incoming.4873fc0a.wav";